// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Layout from "../Layout.re.mjs";
import * as ReactRouterDom from "react-router-dom";
import * as JsxRuntime from "react/jsx-runtime";

import { t } from '@lingui/macro'
;

function WaitForMessages(props) {
  let children = props.children;
  let query = ReactRouterDom.useLoaderData();
  let loaders = query.i18nLoaders;
  if (loaders !== undefined) {
    return JsxRuntime.jsx(ReactRouterDom.Await, {
      children: param => children(),
      resolve: loaders,
      errorElement: JsxRuntime.jsx(Layout.Container.make, {
        children: "Error loading translations"
      })
    });
  } else {
    return children();
  }
}

let make = WaitForMessages;

export {
  make,
}
/*  Not a pure module */
